import { AUTO_REFILL_FREQ_PRESETS } from './auto-refill.constants';
import { escapeHtml, historyStatusClass, historyStatusLabel, pickDto } from './auto-refill.utils';

/** Build the &lt;option&gt; list HTML for cycle-date selectors in the Confirm Refill dialog. */
export function buildCycleOptionsHtml(cycleOptions: any[]): string {
  var html = '';
  var i = 0;
  for (i = 0; i < cycleOptions.length; i++) {
    var value = String(pickDto(cycleOptions[i], 'value', 'Value') || '');
    var label = String(pickDto(cycleOptions[i], 'label', 'Label') || value);
    html += '<option value="' + escapeHtml(value) + '">' + escapeHtml(label) + '</option>';
  }
  return html;
}

/** Build the &lt;option&gt; list HTML for frequency presets in the Edit Schedule dialog. */
export function buildFreqOptionsHtml(selectedPreset: string): string {
  var html = '';
  var i = 0;
  for (i = 0; i < AUTO_REFILL_FREQ_PRESETS.length; i++) {
    var preset = AUTO_REFILL_FREQ_PRESETS[i];
    var selected = preset.id === selectedPreset ? ' selected' : '';
    html += '<option value="' + escapeHtml(preset.id) + '"' + selected + '>' +
      escapeHtml(preset.label) + '</option>';
  }
  return html;
}

/** Build the full HTML content for the Refill History dialog. */
export function buildHistoryHtml(brandName: string, schedule: string, firstFill: string, rows: any[]): string {
  var header =
    '<p class="text-left mb-2"><strong>' + escapeHtml(brandName) + '</strong>' +
    ' — ' + escapeHtml(schedule) + ' | 1st Fill: ' + escapeHtml(firstFill) + '</p>';

  if (!rows || rows.length === 0) {
    return header + '<p class="text-muted mb-0">No history recorded yet.</p>';
  }

  var html =
    header +
    '<div style="max-height:360px;overflow:auto;text-align:left;">' +
    '<table class="table table-hover table-striped table-sm align-middle mb-0">' +
    '<thead class="table-light"><tr>' +
    '<th>Fill Date</th><th>Status</th><th>Note</th><th>Recorded At</th>' +
    '</tr></thead><tbody>';

  var i = 0;
  for (i = 0; i < rows.length; i++) {
    var historyRow = rows[i];
    var statusClass = historyStatusClass(historyRow);
    html +=
      '<tr>' +
      '<td>' + escapeHtml(String(pickDto(historyRow, 'fillDate', 'FillDate') || '')) + '</td>' +
      '<td class="' + statusClass + '">' + escapeHtml(historyStatusLabel(historyRow)) + '</td>' +
      '<td>' + escapeHtml(String(pickDto(historyRow, 'note', 'Note') || '')) + '</td>' +
      '<td>' + escapeHtml(String(pickDto(historyRow, 'recordedAt', 'RecordedAt') || '')) + '</td>' +
      '</tr>';
  }

  html += '</tbody></table></div>';
  return html;
}
